import React, { useState } from "react";
import { Alert, Container } from "react-bootstrap";
import SmartBillForm from "./SmartBill-ImportForm";
import { ApiPost } from "../../../service/ApiService";
import { useNavigate } from "react-router-dom";

const SmartBillImport = () => {
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const [uploadMessage, setUploadMessage] = useState("");
    const [importResult, setImportResult] = useState(null);
    const [responseData, setResponseData] = useState(null);
    const [showForm, setShowForm] = useState(true);
    const [formValues, setFormValues] = useState({
        id: 0,
        clientId: 0,
        issueDate: new Date().toISOString().split("T")[0],
        dueDays: 14,
        useStock: true,
        mentions: "",
        observations: "",
        // defaults
        draft: true,
        seriesName: "SBL",
        currency: "RON",
        language: "RO",
        precision: "2",
        // extracted from customer
        companyVatCode: "",
        dueDate: new Date(new Date().setDate(new Date().getDate() + 14))
            .toISOString()
            .split("T")[0],
        clientName: "",
        clientVatCode: "",
        clientAddress: "",
        clientEmail: "",
        clientCounty: "",
        clientCountry: "Romania",
        saveToDb: false,
        warehouse: ""
    });
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleFileUpload = (e) => {
        e.preventDefault();
        if (!file) {
            setUploadMessage("Te rugăm să selectezi un fișier înainte de a-l încărca.");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("payload", JSON.stringify(formValues));

        ApiPost(
            "/api/smartbill/invoice/import",
            formData,
            (response) => {
                setUploadMessage("Fișierul a fost încărcat cu succes! ");
                setError(null);
                setResponseData(response);
                setShowForm(false);
                setImportResult(response.importResult);
                // Assume the response contains an ID in response.importResult.id
                if (response.importRequestId) {
                    // Redirect to request edit page
                    const editLink = `/smartbill/invoice/edit/${response.importRequestId}`
                    navigate(editLink);
                }
            },
            (error) => {
                setError(
                    error.response?.data?.errorMessage ||
                    "A apărut o eroare în timpul încărcării fișierului."
                );
                setUploadMessage("");
                setResponseData(null);
            }
        );
    };

    return (
        <Container fluid className="mt-5">
            <h1>SmartBill - Import Factură</h1>
            {error && <Alert variant="danger">{error}</Alert>}
            {showForm && (
                <SmartBillForm
                    formValues={formValues}
                    handleInputChange={handleInputChange}
                    handleFileChange={handleFileChange}
                    handleFileUpload={handleFileUpload}
                />
            )}
            {uploadMessage && <Alert variant="info">{uploadMessage}</Alert>}
            {importResult && (
                <Alert variant={importResult.errorText ? "danger" : "success"}>
                    <div>{importResult.message}</div>
                    {importResult.errorText && (
                        <div>
                            <strong>Eroare:</strong> {importResult.errorText}
                        </div>
                    )}
                    {importResult.number && (
                        <div>
                            <strong>Număr:</strong> {importResult.number}
                        </div>
                    )}
                    {importResult.series && (
                        <div>
                            <strong>Serie:</strong> {importResult.series}
                        </div>
                    )}
                    {importResult.url && (
                        <div>
                            <strong>Detalii:</strong>{" "}
                            <a href={importResult.url} target="_blank" rel="noreferrer">
                                {importResult.url}
                            </a>
                        </div>
                    )}
                </Alert>
            )}
            
            {responseData && responseData.error && (
                <Alert variant="danger">
                    {responseData.errorMessage ||
                        "A apărut o eroare în timpul procesării fișierului."}
                </Alert>
            )}
        </Container>
    );
};

export default SmartBillImport;